import { render, staticRenderFns } from "./Yafang.vue?vue&type=template&id=54a19d38&scoped=true&"
import script from "./Yafang.vue?vue&type=script&lang=js&"
export * from "./Yafang.vue?vue&type=script&lang=js&"
import style0 from "./Yafang.vue?vue&type=style&index=0&id=54a19d38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a19d38",
  null
  
)

export default component.exports